{
  "common": {
    "exclusiveSector": "Secteur d'intervention exclusif : Asnières-sur-Seine, Neuilly-sur-Seine, Levallois et alentours proches.",
    "exclusiveSectorPrefix": "Secteur d'intervention exclusif :",
    "exclusiveSectorSuffix": " Asnières-sur-Seine, Neuilly-sur-Seine, Levallois et alentours proches."
  },
  "navbar": {
    "method": "La Méthode",
    "packages": "Nos Forfaits",
    "team": "L'Équipe",
    "clientArea": "Espace Client",
    "audit": "Prendre rendez-vous",
    "portfolio": "Nos réalisations"
  },
  "hero": {
    "subtitle": "Conciergerie & Entretien Haut de Gamme",
    "title1": "L'Excellence,",
    "title2": "Sans Aucun Compromis.",
    "desc": "Un service de ménage exclusif pour les intérieurs les plus exigeants. Confidentialité absolue, prestataires d'élite et suivi rigoureux par notre fondatrice.",
    "btnEstimate": "Estimer mon forfait",
    "btnMethod": "Découvrir la méthode",
    "btnJoin": "Adhérer à un forfait"
  },
  "calculator": {
    "sectionTag": "Votre Étude Personnalisée",
    "sectionTitle": "Configurer votre forfait",
    "step1": "Niveau d'Exigence",
    "step2": "La Propriété",
    "step3": "Spécificités & Exigences",
    "perHour": "/ h",
    "afterTax": "Après 50% crédit d'impôt",
    "grossPerHour": "{{price}}€ / h brut",
    "surface": "Superficie",
    "surfaceUnit": "m²",
    "roomsLabel": "Pièces de vie",
    "bathroomsLabel": "Salles de bain",
    "kitchensLabel": "Cuisines",
    "note": "Note : Les frais de pressing externes ou le montant des courses alimentaires restent à l'entière charge du client et seront refacturés à l'euro près, sans marge.",
    "studySummary": "Votre Étude",
    "estimatedTime": "Temps estimé",
    "timeUnit": "h / sem",
    "serviceLevel": "Niveau de service",
    "grossMonthly": "Forfait Brut Mensuel",
    "advanceBadge": "Avance immédiate -50%",
    "netMonthly": "Forfait Net Mensuel",
    "btnAudit": "Solliciter un audit",
    "noCommitment": "Estimation indicative sans engagement",
    "packages": {
      "essentiel": {
        "name": "Essentiel Premium",
        "desc": "Entretien approfondi avec des produits écologiques haut de gamme."
      },
      "signature": {
        "name": "Maison Signature",
        "desc": "Inclut la gestion fine du linge, le repassage et l'organisation."
      },
      "intendance": {
        "name": "Intendance Absolue",
        "desc": "Conciergerie VIP, soin des matériaux rares, courses et logistique."
      }
    },
    "specifics": {
      "pets": {
        "label": "Animaux de compagnie",
        "desc": "Gestion des poils, précautions particulières"
      },
      "children": {
        "label": "Enfants en bas âge",
        "desc": "Désinfection douce, rangement minutieux"
      },
      "art": {
        "label": "Œuvres d'art & Collections",
        "desc": "Dépoussiérage délicat, aucun produit chimique"
      },
      "marble": {
        "label": "Matériaux nobles",
        "desc": "Marbre, laiton, bois massif, cuirs"
      },
      "dressing": {
        "label": "Dressing & Linge",
        "desc": "Pliage Marie Kondo, gestion pressing"
      },
      "silver": {
        "label": "Argenterie & Cristallerie",
        "desc": "Lavage et lustrage à la main"
      },
      "groceries": {
        "label": "Gestion des courses",
        "desc": "Approvisionnement produits frais"
      },
      "plants": {
        "label": "Plantes & Balcons",
        "desc": "Entretien végétal, arrosage régulier"
      }
    },
    "vipFrom": "À partir de",
    "vipText": "Chaque intérieur est unique et mérite une attention particulière. Pour valider ce tarif au centime près et concevoir votre cahier des charges, ",
    "vipAction": "réservez votre audit gratuit à domicile ci-dessous."
  },
  "taxCredit": {
    "title": "L'Avance Immédiate : Zéro Paperasse",
    "subtitle": "Profitez de 50% de crédit d'impôt instantané. Nous gérons l'administratif pour vous.",
    "step1Title": "L'Inscription Simplifiée",
    "step1Desc": "Johanna se charge de créer votre compte URSSAF de service à la personne.",
    "step2Title": "La Validation",
    "step2Desc": "Vous recevez un simple email de l'URSSAF. Un clic suffit pour activer votre compte.",
    "step3Title": "Le Prélèvement Divisé",
    "step3Desc": "Chaque mois, l'URSSAF ne prélève sur votre compte que 50% de la facture. L'État paie le reste."
  },
  "legal": {
    "mentions": {
      "title": "Mentions Légales",
      "content": "Éditeur du site : L'art du Ménage par Johanna.\nSiège social : Asnières-sur-Seine.\nDirecteur de la publication : Johanna.\nHébergement : Vercel / Netlify."
    },
    "privacy": {
      "title": "Politique de Confidentialité",
      "content": "La confidentialité est notre priorité absolue. L'ensemble des données collectées (plans, spécificités du domicile, adresses) sont cryptées et protégées par des accords de non-divulgation (NDA) stricts."
    },
    "cgv": {
      "title": "Conditions Générales de Vente",
      "content": "Toute prestation est soumise à l'acceptation du devis après audit sur place. Les annulations doivent être notifiées 48h à l'avance."
    }
  },
  "faq": {
    "title": "Questions Fréquentes & Impôts",
    "q1": "Comment fonctionne l'Avance Immédiate ?",
    "a1": "Nous vous inscrivons à l'URSSAF. Vous ne payez que 50% de la facture chaque mois, l'État paie directement le reste.",
    "q2": "Qui intervient chez moi ?",
    "a2": "Des professionnels triés sur le volet, formés à l'hôtellerie de luxe, disposant d'un casier judiciaire vierge et ayant signé un accord de confidentialité.",
    "q3": "En cas de dommage ?",
    "a3": "Nous disposons d'une assurance Responsabilité Civile Professionnelle spécifique couvrant les objets de très haute valeur."
  },
  "linge": {
    "title": "Le Soin du Linge",
    "subtitle": "Un traitement digne des grands hôtels",
    "desc": "Repassage parfait, pliage au millimètre et respect des matières nobles (soie, cachemire). Votre dressing est organisé méthodiquement.",
    "detailTitle": "L'Exigence du Détail"
  },
  "engagements": {
    "heroTag": "Notre Contrat de Confiance",
    "heroTitle1": "Nos",
    "heroTitle2": "Engagements",
    "introTitle": "L'intransigeance au service de votre sérénité.",
    "introDesc": "Entrer dans l'intimité de votre foyer est un privilège que nous honorons par une exigence absolue. Chez <strong class=\"text-black-deep font-serif\">L'Art du Ménage par Johanna</strong>, nous ne faisons aucune concession sur l'éthique, la sécurité et la qualité. Nos engagements ne sont pas de simples promesses commerciales, ce sont les fondations inébranlables de notre méthode.",
    "ctaTag": "Rejoignez le cercle",
    "ctaTitle": "Prêt à déléguer en toute confiance ?",
    "ctaDesc": "Demandez votre audit privé pour définir ensemble le cahier des charges de votre intérieur.",
    "ctaBtn": "Prendre rendez-vous",
    "commitments": [
      {
        "title": "Discrétion Absolue",
        "desc": "Le vrai luxe est silencieux. Nos gouvernantes signent un accord de confidentialité strict (NDA). Votre vie privée reste derrière vos portes closes. Aucune information, aucune photo (hors rapport sécurisé) ne filtre."
      },
      {
        "title": "Écologie Haute Performance",
        "desc": "Nous bannissons la chimie toxique. Nous utilisons exclusivement des solutions écologiques certifiées, des cires naturelles et des huiles essentielles qui préservent votre santé, vos matériaux nobles et l'environnement."
      },
      {
        "title": "Garantie Zéro Défaut",
        "desc": "L'erreur humaine existe, l'exigence de perfection la corrige. Si une prestation ne correspond pas à nos standards ou à votre cahier des charges, nous ré-intervenons sous 24h, à nos frais. L'excellence n'est pas une option."
      },
      {
        "title": "Personnel d'Élite",
        "desc": "Nos intervenants sont recrutés selon les critères des palaces parisiens. Formés en continu à l'hôtellerie de luxe, ils sont également rémunérés bien au-dessus des standards du marché pour garantir leur fidélité et leur implication."
      },
      {
        "title": "Sécurité Infaillible",
        "desc": "Votre confiance est notre plus grand capital. Les clés confiées sont anonymisées et stockées dans un coffre-fort biométrique. Les antécédents judiciaires (Casier B3) de tous nos collaborateurs sont vérifiés avant toute embauche."
      },
      {
        "title": "Transparence Totale",
        "desc": "Un rapport photographique détaillé après chaque passage, une facturation claire sans frais cachés, et la prise en charge immédiate de l'avance de crédit d'impôt URSSAF. Nous gérons tout, vous gardez le contrôle."
      }
    ]
  },
  "home": {
    "founder": {
      "tag": "Le mot de la fondatrice",
      "title1": "L'obsession du",
      "title2": "détail parfait.",
      "p1": "Après des années à constater le manque de rigueur dans les services d'entretien traditionnels, j'ai décidé de créer le service que je n'arrivais pas à trouver pour ma propre maison.",
      "p2": "Je suis ce que l'on appelle une maniaque. Pour moi, le ménage n'est pas une corvée, c'est un art. L'art de sublimer des matériaux nobles, l'art de préserver un environnement sain, et surtout, l'art de la discrétion absolue.",
      "p3": "C'est pourquoi j'audite personnellement chaque nouvelle propriété et j'effectue des contrôles surprises hebdomadaires. Mon exigence est votre plus grande garantie.",
      "name": "JOHANNA",
      "role": "Directrice & Fondatrice",
      "alt": "Johanna, Fondatrice"
    },
    "features": {
      "tag": "Garantie Inconditionnelle",
      "title1": "L'Art de",
      "title2": "l'Excellence",
      "desc": "Quatre piliers fondamentaux qui redéfinissent les standards du service de prestige à domicile. Nous ne faisons aucun compromis sur la perfection.",
      "scroll": "Découvrir nos promesses",
      "items": [
        {
          "title": "Gouvernantes",
          "titleItalic": " d'Élite",
          "desc": "Toutes nos gouvernantes parlent un français parfait et justifient de nombreuses années d'expérience dans l'hôtellerie de luxe ou l'entretien de demeures de prestige. L'approximation n'a pas sa place chez nous."
        },
        {
          "title": "Confidentialité",
          "titleItalic": " Absolue",
          "desc": "Signature systématique d'un accord de non-divulgation (NDA) préalable. Votre intimité est un sanctuaire que nous préservons avec une rigueur et un mutisme absolus."
        },
        {
          "title": "Suivi",
          "titleItalic": " Obsessionnel",
          "desc": "L'excellence n'est jamais laissée au hasard. Des inspections inopinées garantissent une exécution méticuleuse et systématiquement parfaite de nos protocoles d'entretien."
        },
        {
          "title": "Optimisation",
          "titleItalic": " Fiscale",
          "desc": "L'élégance d'un service haut de gamme couplée à l'intelligence financière. Bénéficiez immédiatement de 50% d'avantage fiscal, sans aucune avance de trésorerie."
        }
      ]
    },
    "exclusivity": {
      "title1": "L'Exigence Absolue",
      "title2": "Une Maison",
      "title3": "Réservée à l'Élite",
      "tag": "Cercle Privé",
      "p1": "L'Art du Ménage n'est pas une simple société de nettoyage. C'est une institution privée dédiée à la perfection.",
      "p2": "Nous avons fait le choix de la qualité absolue au détriment de la quantité. Nos gouvernantes sont des expertes du détail, formées pour satisfaire les niveaux d'exigence les plus hauts. Parce que votre intérieur est précieux, nous n'y accordons que le meilleur de notre expertise.",
      "btn": "Solliciter une adhésion",
      "items": [
        {
          "title": "Sélection Rigoureuse",
          "desc": "Nous n'acceptons pas toutes les demandes. Nous privilégions les clients recommandés et ceux qui partagent notre vision du raffinement et du respect."
        },
        {
          "title": "Un Travail Maniaque",
          "desc": "Notre approche est pointilleuse, quasi obsessionnelle. Chaque recoin, chaque surface est traité avec une perfection intransigeante."
        },
        {
          "title": "Le Prix de l'Exception",
          "desc": "Une qualité de service inégalée implique un tarif en conséquence. Nos prestations sont conçues pour une élite qui refuse le compromis."
        }
      ]
    },
    "timeline": {
      "tag": "L'Excellence Étape par Étape",
      "title": "Notre Méthodologie",
      "items": [
        {
          "title": "L'Audit Initial",
          "desc": "Rencontre avec Johanna à votre domicile pour comprendre vos exigences, lister les particularités de l'habitation et choisir le forfait adapté."
        },
        {
          "title": "Contrat & Discrétion",
          "desc": "Signature du contrat d'intervention et de l'accord de confidentialité (NDA). Vos clés sont sécurisées et anonymisées."
        },
        {
          "title": "Prestations d'Élite",
          "desc": "Intervention de nos prestataires formés aux protocoles stricts, avec un suivi en temps réel via l'espace client (photos de fin d'intervention)."
        },
        {
          "title": "Contrôles Qualité",
          "desc": "Visites surprises de Johanna pendant ou après les interventions pour garantir un niveau de perfection constant."
        }
      ]
    }
  },
  "methode": {
    "heroTag": "L'Exigence pour Doctrine",
    "heroTitle1": "Notre",
    "heroTitle2": "Méthode",
    "manifestoTag": "Le Manifeste",
    "manifestoTitle1": "L'art du ménage",
    "manifestoTitle2": "ne s'improvise pas.",
    "manifestoP1": "Il exige une rigueur militaire alliée à une délicatesse absolue. Nous ne nous contentons pas de nettoyer ; nous restaurons l'harmonie parfaite de votre intérieur.",
    "manifestoP2": "Chaque geste de nos prestataires d'élite est codifié, anticipé et mesuré. Chaque produit écologique haut de gamme est rigoureusement sélectionné pour son efficacité chirurgicale et son respect absolu de vos matériaux les plus précieux.",
    "manifestoP3": "Nous considérons que la véritable propreté est invisible : c'est l'absence totale de défaut, le parfum subtil du propre, et l'ordre parfait qui règnent après notre passage.",
    "protocolTag": "Les 8 Règles d'Or",
    "protocolTitle": "Le Protocole",
    "protocolDesc": "Cliquez sur chaque règle pour plonger au cœur de notre cahier des charges et découvrir le niveau de détail exigé.",
    "modalTag": "Règle d'or",
    "recruitmentTag": "Seuls 3% de réussite",
    "recruitmentTitle1": "La Formation de",
    "recruitmentTitle2": "l'Élite",
    "recruitmentDesc": "À l'issue de sélections drastiques, nos candidates suivent une formation intensive de 4 semaines sur les protocoles stricts de l'hôtellerie de luxe avant leur toute première intervention.",
    "recruitmentBtn": "Postuler pour nous rejoindre",
    "rules": [
      {
        "title": "Désinfection Systématique",
        "subtitle": "Hygiène hospitalière pour vos points de contact.",
        "detail": "Interrupteurs, poignées de porte, télécommandes et robinetteries sont désinfectés avec des produits écologiques ultra-performants de grade hospitalier. Nous portons une attention obsessionnelle aux zones invisibles, souvent négligées par les services standards, pour vous garantir un environnement sanitairement parfait."
      },
      {
        "title": "Microfibres Exclusives",
        "subtitle": "Un protocole strict anti-contamination croisée.",
        "detail": "Notre code couleur est intransigeant (rouge pour les sanitaires, bleu pour les surfaces de vie, etc.). Chaque microfibre n'est utilisée que pour une seule zone spécifique de votre domicile. Cela garantit une hygiène absolue et annule tout risque de contamination croisée entre les pièces."
      },
      {
        "title": "Standard Palace (Linge)",
        "subtitle": "L'art du pliage Marie Kondo.",
        "detail": "Vos serviettes et vêtements sont manipulés avec des gants blancs, puis pliés au millimètre près selon la méthode Marie Kondo et les standards stricts des palaces parisiens. Nous assurons un alignement géométrique parfait dans vos tiroirs et dressings."
      },
      {
        "title": "Purification de l'Air",
        "subtitle": "Respiration et signature olfactive.",
        "detail": "Nous procédons à un renouvellement complet de l'air de chaque pièce pendant toute la durée de l'intervention. L'opération se clôture par la vaporisation subtile de notre signature olfactive exclusive, laissant derrière nous une sensation de pureté immédiate."
      },
      {
        "title": "Soin des Matériaux Nobles",
        "subtitle": "Expertise sur marbre, bois et cuirs.",
        "detail": "Aucun produit d'entretien générique n'est toléré chez nous. Nous utilisons exclusivement des baumes nourrissants haut de gamme pour vos cuirs, de la cire naturelle pour vos bois rares, et des solutions au pH parfaitement neutre pour préserver l'éclat originel de vos marbres."
      },
      {
        "title": "Disposition Symétrique",
        "subtitle": "Restauration de l'harmonie visuelle.",
        "detail": "Chaque objet, livre ou bibelot déplacé pour le nettoyage est remis exactement à sa place. Nous portons une attention maniaque à la symétrie de vos coussins, à l'alignement de vos chaises et au tombé parfait de vos rideaux. Votre intérieur retrouve son équilibre."
      },
      {
        "title": "Inspection de 15 Minutes",
        "subtitle": "Le contrôle qualité silencieux.",
        "detail": "Avant de quitter les lieux, la gouvernante s'arrête. Elle effectue un contrôle qualité silencieux et méticuleux de 15 minutes, croisant son regard d'experte avec une checklist numérique intraitable comprenant plus de 40 points de contrôle obligatoires."
      },
      {
        "title": "Rapport Photo Sécurisé",
        "subtitle": "Preuve d'excellence via votre espace VIP.",
        "detail": "La confiance n'exclut pas le contrôle. Une fois notre intervention validée, vous recevez une notification discrète sur votre espace client privé. Vous y trouverez un rapport photographique prouvant l'excellence du travail accompli dans chacune de vos pièces."
      }
    ]
  },
  "forfaits": {
    "heroTag": "L'Excellence Tarifée",
    "heroTitle1": "Nos",
    "heroTitle2": "Forfaits",
    "pricingTag": "Un service sur-mesure",
    "pricingTitle": "Haute Couture de l'Entretien",
    "pricingDesc": "Trois niveaux d'exigence pour répondre aux standards de votre style de vie. Tarifs horaires calculés à l'heure, ajustés selon la surface lors de notre simulateur.",
    "popular": "Le plus demandé",
    "grossPrice": "Tarif brut :",
    "netPrice": "/ h net*",
    "netPriceDisclaimer": "*Après 50% d'avance immédiate",
    "btnAudit": "Demander un Audit",
    "taxTag": "Avantage Fiscal",
    "taxTitle1": "L'Avance Immédiate :",
    "taxTitle2": "Zéro Paperasse.",
    "taxP1": "Profitez de 50% de crédit d'impôt instantané.",
    "taxP2": "Oubliez les déclarations fastidieuses et l'attente du remboursement l'année suivante. L'État finance instantanément 50% de vos factures. <strong class=\"text-white font-normal\">Nous gérons intégralement l'administratif pour vous.</strong> Vous ne payez que le reste à charge.",
    "taxFeature1Title": "Aucune démarche",
    "taxFeature1Desc": "Nous créons votre compte URSSAF.",
    "taxFeature2Title": "Validation 1 clic",
    "taxFeature2Desc": "Approuvez via SMS ou email.",
    "taxExample": "Exemple : Facture Mensuelle",
    "taxState": "Prise en charge URSSAF (50%)",
    "taxRemaining": "Reste à charge",
    "taxRemainingSub": "Prélevé sur votre compte",
    "packages": [
      {
        "name": "Essentiel Premium",
        "desc": "L'excellence quotidienne pour un intérieur parfaitement tenu.",
        "features": [
          "Nettoyage approfondi de toutes les pièces",
          "Aspiration et lavage des sols durs",
          "Dépoussiérage du mobilier standard",
          "Désinfection complète des sanitaires",
          "Utilisation de nos produits écologiques"
        ]
      },
      {
        "name": "Maison Signature",
        "desc": "L'art du soin étendu à votre garde-robe et votre linge.",
        "features": [
          "Tout le forfait Essentiel Premium",
          "Gestion experte du linge de maison",
          "Repassage professionnel sur place",
          "Pliage Marie Kondo & Rangement dressing",
          "Changement régulier des parures de lit"
        ]
      },
      {
        "name": "Intendance Absolue",
        "desc": "La conciergerie privée 5 étoiles pour un esprit libéré.",
        "features": [
          "Tout le forfait Maison Signature",
          "Soin spécifique des matériaux nobles (marbre, bois, cuir)",
          "Dépoussiérage délicat des œuvres d'art",
          "Gestion des courses et pressing",
          "Réception des colis & coordination prestataires"
        ]
      }
    ]
  },
  "audit": {
    "heroTitle": "Demander un Audit",
    "heroSubtitle": "Votre Étude Personnalisée",
    "errorIncomplete": "Veuillez remplir tous les champs obligatoires (Nom, Email, Téléphone, Adresse).",
    "errorSend": "Une erreur est survenue lors de l'envoi.",
    "errorAlert": "Une erreur est survenue lors de l'envoi de votre demande. Nos équipes sont averties.",
    "successTitle": "Demande Confirmée",
    "successDesc": "Nous avons bien reçu votre demande. Johanna vous contactera dans les plus brefs délais pour fixer un rendez-vous.",
    "formTitle": "Planifier l'Audit à Domicile",
    "formDesc": "Johanna se déplacera personnellement pour évaluer les spécificités de votre propriété et établir un cahier des charges précis.",
    "labelName": "Nom Complet",
    "labelPhone": "Téléphone",
    "labelEmail": "Email",
    "labelAddress": "Adresse Complète",
    "labelProperty": "Type de Propriété",
    "labelMessage": "Message Spécifique (Optionnel)",
    "propAppart": "Appartement de Standing",
    "propHouse": "Maison / Villa",
    "propMansion": "Hôtel Particulier",
    "btnSubmit": "Demander mon Audit Exclusif",
    "btnLoading": "Traitement..."
  },
  "recrutement": {
    "heroTitle": "Rejoindre l'Élite",
    "heroSubtitle": "Recrutement",
    "errorIncomplete": "Veuillez remplir tous les champs obligatoires.",
    "errorAlert": "Une erreur est survenue. Veuillez réessayer.",
    "successTitle": "Candidature Reçue",
    "successDesc": "Johanna étudiera votre profil avec la plus grande attention.",
    "formTitle": "Devenez Gouvernante d'Excellence",
    "formDesc": "Nous recherchons des profils dotés d'un sens aigu du détail, formés aux standards de l'hôtellerie de luxe.",
    "labelName": "Nom Complet",
    "labelPhone": "Téléphone",
    "labelEmail": "Email",
    "labelExperience": "Années d'expérience en Hôtellerie / Maison de Maître",
    "expSelect": "Sélectionner...",
    "exp1": "1 à 3 ans",
    "exp2": "3 à 5 ans",
    "exp3": "Plus de 5 ans",
    "labelMotivation": "Vos Motivations",
    "btnSubmit": "Soumettre ma Candidature",
    "btnLoading": "Envoi..."
  },
  "login": {
    "errorConfig": "Erreur de configuration serveur.",
    "errorAuth": "Identifiants incorrects ou compte inexistant.",
    "msgSuccess": "Connexion réussie. Ouverture de votre Espace Privilégié...",
    "errorEmailReq": "Veuillez renseigner votre email.",
    "errorReset": "Erreur lors de l'envoi de l'email.",
    "msgResetSuccess": "Si cet email existe, un lien de réinitialisation vient de vous être envoyé.",
    "brandTitle": "L'ART DU MÉNAGE",
    "brandSubtitle": "par Johanna",
    "brandDesc": "L'excellence ne s'arrête pas au pas de votre porte. Retrouvez vos rapports photographiques, vos factures et l'état de votre avance immédiate URSSAF sur votre Espace Privilégié.",
    "formTitle": "Espace Privilégié",
    "formDescLogin": "Veuillez vous identifier pour accéder à vos documents confidentiels.",
    "formDescReset": "Entrez votre email pour réinitialiser votre mot de passe d'accès.",
    "labelEmail": "Email de contact",
    "labelPassword": "Mot de passe d'accès",
    "rememberMe": "Se souvenir de moi",
    "forgotPass": "Accès oublié ?",
    "btnLoading": "Chargement...",
    "btnLogin": "Accéder à mon espace",
    "btnReset": "Réinitialiser",
    "backLogin": "Retour à la connexion",
    "footerNote": "L'adhésion et la création de compte se font exclusivement sur audit par la direction.",
    "backHome": "Retour à l'accueil"
  },
  "dashboard": {
    "brandArea": "ESPACE PRIVILÉGIÉ",
    "navDashboard": "Tableau de bord",
    "navInvoices": "Mes Factures",
    "navReports": "Rapports d'Intervention",
    "navSettings": "Réglages",
    "navLogout": "Déconnexion",
    "welcome": "Bienvenue",
    "accountOf": "Compte de {{email}}",
    "urssafTitle": "Avance Immédiate URSSAF",
    "urssafDesc": "Votre compte URSSAF est actif et lié à L'Art du Ménage. L'état prend en charge 50% de vos factures instantanément.",
    "urssafRemaining": "Reste à charge ce mois-ci",
    "nextIntervention": "Prochaine Intervention",
    "nextStatus": "En attente de planification",
    "nextDesc": "Aucune intervention n'est prévue dans les 7 prochains jours. Contactez votre conciergerie pour planifier un passage.",
    "btnContact": "Contacter la Conciergerie",
    "reportsTitle": "Rapports d'Intervention",
    "reportSample": "Rapport - Juin 2026",
    "reportDesc": "Photos Avant/Après • Check-list complète",
    "noMoreReports": "Aucun autre rapport disponible.",
    "invoicesTitle": "Dernières Factures",
    "invoiceSample": "Facture N° 2026-06-01",
    "invoiceDesc": "Traitée via Avance Immédiate",
    "noMoreInvoices": "Aucune autre facture disponible."
  },
  "ville": {
    "headerTitle": "Votre Conciergerie à {{cityName}}",
    "headerSubtitle": "Intervention Locale",
    "sectionTitle": "L'Excellence à {{cityName}}",
    "desc1": "Parce que les demeures de {{cityName}} exigent une attention toute particulière, L'art du Ménage par Johanna déploie ses équipes d'élite dans votre secteur. Que vous résidiez dans une maison de maître ou un appartement de standing, nous appliquons nos protocoles de conciergerie haut de gamme avec une discrétion absolue.",
    "desc2": "Profitez de la proximité de nos équipes pour un audit initial rapide à {{cityName}}. Johanna se déplace personnellement pour évaluer vos besoins."
  },
  "footer": {
    "brandTitle": "L'ART DU MÉNAGE",
    "brandSubtitle": "par Johanna",
    "brandDesc": "L'excellence au quotidien. Un service de conciergerie et d'entretien exclusif pour les intérieurs les plus exigeants.",
    "col1Title": "La Maison",
    "col1Mentions": "Mentions Légales",
    "col1Privacy": "Politique de Confidentialité",
    "col1Cgv": "Conditions Générales de Vente",
    "col2Title": "Nos Services",
    "col2Packages": "Les Forfaits",
    "col2Laundry": "Le Soin du Linge",
    "col2Zones": "Zones d'Intervention :",
    "col3Title": "Contact",
    "col3Vip": "Espace Client VIP",
    "col3Faq": "FAQ & Crédit d'Impôt",
    "col3Commitments": "Nos Engagements",
    "copyright": "© {{year}} L'art du Ménage par Johanna. Tous droits réservés.",
    "bottomMentions": "Mentions légales",
    "bottomPrivacy": "Politique de confidentialité",
    "bottomCgv": "CGV"
  },
  "faqPage": {
    "headerTitle": "Foire Aux Questions",
    "headerSubtitle": "Assistance, Transparence & Cadre Légal",
    "themes": "Thématiques",
    "data": [
      {
        "category": "L'Avance Immédiate URSSAF",
        "items": [
          {
            "q": "Qu'est-ce que l'Avance Immédiate de crédit d'impôt ?",
            "a": "C'est un service optionnel et gratuit mis en place par l'URSSAF. Il vous permet de déduire immédiatement votre crédit d'impôt de 50% de vos factures de Services à la Personne. Vous ne payez plus que votre reste à charge."
          },
          {
            "q": "Comment activer ce service ?",
            "a": "Lors de notre audit initial, si vous êtes éligible, nous créons votre compte URSSAF. Vous recevez un email pour activer votre compte. Tout est automatisé."
          },
          {
            "q": "Dois-je faire une démarche administrative ?",
            "a": "Non, L'Art du Ménage s'occupe de toutes les déclarations. Vous n'avez qu'à valider notre demande de prélèvement sur votre espace URSSAF."
          },
          {
            "q": "Qui prélève le montant de la facture ?",
            "a": "C'est l'URSSAF qui prélève votre reste à charge (50% de la facture) directement sur votre compte bancaire 2 jours après la validation de la facture."
          },
          {
            "q": "Y a-t-il un plafond pour le crédit d'impôt ?",
            "a": "Oui, le plafond annuel de dépenses est de 12 000€, majorable selon la composition de votre foyer (enfants à charge, personnes âgées). Soit 6 000€ de réduction maximum par an."
          },
          {
            "q": "Que se passe-t-il si la plateforme URSSAF est en panne ?",
            "a": "En cas de défaillance technique de l'URSSAF, la totalité de la facture reste due à L'Art du Ménage. Nous vous fournirons une attestation fiscale pour récupérer vos 50% l'année suivante."
          },
          {
            "q": "Ce service est-il réservé aux personnes imposables ?",
            "a": "Absolument pas. Il s'agit d'un crédit d'impôt. Si vous ne payez pas d'impôts ou si le montant de vos impôts est inférieur à votre crédit, l'administration fiscale vous rembourse la différence."
          }
        ]
      },
      {
        "category": "La Méthodologie & Les Prestations",
        "items": [
          {
            "q": "Quelles sont vos règles d'or ?",
            "a": "Nous appliquons 8 règles d'or inspirées de l'hôtellerie de luxe : désinfection, microfibres spécifiques, soin des matériaux nobles, protocole aération, respect de la symétrie, inspection de 15 min, et rapport détaillé."
          },
          {
            "q": "Fournissez-vous le matériel ?",
            "a": "Oui. Nos gouvernantes viennent avec leur propre matériel de pointe, notamment un jeu de microfibres à code couleur pour éviter la contamination croisée, et des produits écologiques très haut de gamme."
          },
          {
            "q": "Utilisez-vous des produits toxiques ?",
            "a": "Non. Nous bannissons la chimie lourde. Nous utilisons des solutions naturelles, des huiles essentielles et des cires adaptées aux matériaux rares (marbre, bois massif, cuirs)."
          },
          {
            "q": "Puis-je imposer mes propres produits ?",
            "a": "Oui, si vous avez des exigences spécifiques (par exemple pour une œuvre d'art ou un meuble ancien), nous respecterons scrupuleusement vos consignes notées lors de l'audit."
          },
          {
            "q": "Combien de temps dure une prestation ?",
            "a": "Cela dépend de votre forfait et de l'audit initial. Nous ne facturons pas à l'heure pure mais au résultat, bien que nous évaluons une enveloppe horaire pour le planning de nos gouvernantes."
          },
          {
            "q": "Est-ce toujours la même personne qui intervient ?",
            "a": "Oui. Sauf congés ou maladie, une gouvernante attitrée est responsable de votre intérieur pour garantir une connaissance parfaite de vos habitudes."
          },
          {
            "q": "Faites-vous le repassage et le dressing ?",
            "a": "Le repassage de base est inclus dans notre Forfait Signature. Pour un rangement expert (par couleurs, saisons, pliage au gabarit), nous proposons des prestations dédiées."
          },
          {
            "q": "Que couvre l'inspection finale de 15 minutes ?",
            "a": "À la fin de chaque prestation, la gouvernante s'arrête de nettoyer et consacre 15 minutes uniquement au contrôle visuel, ajustement des coussins, alignement des objets et vérification des reflets."
          }
        ]
      },
      {
        "category": "Sécurité & Confidentialité",
        "items": [
          {
            "q": "Comment gérez-vous mes clés ?",
            "a": "Vos clés sont anonymisées (aucun nom ni adresse dessus) et stockées dans un coffre-fort biométrique. Elles ne sont sorties que le jour de la prestation."
          },
          {
            "q": "Vos collaborateurs sont-ils contrôlés ?",
            "a": "Le recrutement est drastique. Nous exigeons un extrait de casier judiciaire (B3) vierge, des références vérifiables, et une formation à la discrétion totale."
          },
          {
            "q": "Signez-vous un accord de confidentialité (NDA) ?",
            "a": "Oui, tous nos employés signent un Accord de Non-Divulgation très strict. Votre vie privée, votre identité et l'intérieur de votre domicile restent secrets."
          },
          {
            "q": "Qu'est-ce que le rapport photographique ?",
            "a": "Via votre espace VIP, vous recevez un rapport après chaque passage avec des photos des zones critiques (avant/après). Ces photos sont chiffrées et supprimées régulièrement."
          },
          {
            "q": "Que se passe-t-il si un objet de valeur est cassé ?",
            "a": "Nous possédons une assurance Responsabilité Civile Professionnelle spécifique haut de gamme. En cas de bris (signalé sous 48h), notre assurance prend le relais."
          },
          {
            "q": "La gouvernante a-t-elle le droit de prendre son téléphone ?",
            "a": "L'usage du téléphone personnel est strictement interdit pendant la prestation, sauf pour générer le rapport photographique chiffré via notre application métier."
          }
        ]
      },
      {
        "category": "Facturation & Contrats",
        "items": [
          {
            "q": "L'audit initial est-il payant ?",
            "a": "Non, l'audit physique de votre domicile (ou en visioconférence) pour établir votre cahier des charges est totalement gratuit et sans engagement."
          },
          {
            "q": "Y a-t-il un engagement de durée ?",
            "a": "Nos forfaits récurrents sont sans engagement de durée après le premier mois d'essai, avec un simple préavis de résiliation de 30 jours."
          },
          {
            "q": "Comment annuler ou reporter une intervention ?",
            "a": "Vous pouvez reporter via votre conciergerie privée. Nous exigeons un délai de 48 heures ouvrées. Toute annulation tardive entraîne une facturation à 50%."
          },
          {
            "q": "Y a-t-il des frais de dossier cachés ?",
            "a": "Aucun. Nos tarifs sont nets. La création du compte URSSAF, la gestion administrative et le déplacement sont inclus dans vos forfaits."
          },
          {
            "q": "Comment accéder à mes factures ?",
            "a": "Elles sont toutes disponibles et téléchargeables au format PDF depuis votre Espace Privilégié sécurisé."
          }
        ]
      },
      {
        "category": "Conciergerie & Options",
        "items": [
          {
            "q": "Proposez-vous un service pressing externe ?",
            "a": "Oui, notre service 'Soin du Linge & Pressing' inclut la collecte et la livraison de vos pièces délicates vers des pressings partenaires d'excellence."
          },
          {
            "q": "Pouvez-vous réceptionner des colis en mon absence ?",
            "a": "C'est possible dans le cadre du Forfait Absolu (Conciergerie), sous réserve que cela se déroule pendant nos heures d'intervention."
          },
          {
            "q": "Faites-vous les courses ?",
            "a": "Nous pouvons gérer le réassort de vos produits de base (frigo, épicerie fine, fleurs fraîches) en option via notre service d'intendance."
          },
          {
            "q": "Intervenez-vous pour des urgences ou après réception ?",
            "a": "Nous proposons un service 'Lendemain de Réception' pour nos clients sous forfait, afin de remettre votre intérieur à l'état initial après un événement privé."
          }
        ]
      }
    ]
  },
  "cgvPage": {
    "headerTitle": "Conditions Générales de Vente",
    "headerSubtitle": "Prestations de Services à la Personne",
    "lastUpdate": "Dernière mise à jour : {{date}}",
    "art1Title": "Article 1 - Objet et Champ d'Application",
    "art1P1": "Les présentes Conditions Générales de Vente (CGV) définissent les droits et obligations des parties dans le cadre de la vente des prestations de services d'entretien et de conciergerie à domicile proposées par <strong>L'Art du Ménage par Johanna</strong> (ci-après \"le Prestataire\") au client (ci-après \"le Client\").",
    "art1P2": "Le Prestataire intervient exclusivement au domicile de particuliers et propose des services éligibles au régime des Services à la Personne (SAP), conformément aux dispositions de l'article L. 7231-1 du Code du travail.",
    "art2Title": "Article 2 - Modalités d'Intervention et d'Audit",
    "art2_1Title": "2.1. L'Audit Initial Obligatoire",
    "art2_1P1": "Toute nouvelle adhésion fait l'objet d'un audit physique ou en visioconférence préalable au domicile du Client. Cet audit permet de définir le niveau d'exigence, la superficie, la nature des matériaux (marbre, bois rares, cuir) et le cahier des charges spécifique. L'audit donne lieu à l'émission d'un devis personnalisé gratuit.",
    "art2_2Title": "2.2. Remise des Clés et Sécurité",
    "art2_2P1": "Le Client confiant un jeu de clés au Prestataire signe un registre de remise des clés. Les clés sont anonymisées et conservées dans un coffre-fort biométrique par la direction. Le Prestataire garantit la sécurité absolue des accès.",
    "art3Title": "Article 3 - Tarification et Facturation",
    "art3_1Title": "3.1. Tarifs",
    "art3_1P1": "Les tarifs sont communiqués TTC (Toutes Taxes Comprises) au Client lors du devis. Ils dépendent du forfait choisi (Essentiel, Signature, Absolu) et de la récurrence des interventions.",
    "art3_2Title": "3.2. Avance Immédiate de Crédit d'Impôt (URSSAF)",
    "art3_2P1": "Le Prestataire étant habilité par l'URSSAF, le Client peut bénéficier, s'il y est éligible, de l'Avance Immédiate. Dans ce cadre :",
    "art3_2L1": "Le Prestataire crée le compte URSSAF du Client avec son accord.",
    "art3_2L2": "Le Client valide la demande d'inscription.",
    "art3_2L3": "Le Prestataire transmet les factures à l'URSSAF.",
    "art3_2L4": "L'URSSAF prélève uniquement le reste à charge (50% de la facture) sur le compte bancaire du Client, dans la limite de son plafond annuel (12 000 € majorable).",
    "art3_2Note": "En cas de dysfonctionnement de la plateforme de l'URSSAF ou d'inéligibilité, la totalité de la facture reste due par le Client au Prestataire, qui lui fournira une attestation fiscale annuelle en janvier de l'année suivante.",
    "art4Title": "Article 4 - Droit de Rétractation",
    "art4P1": "Conformément à l'article L.221-18 du Code de la consommation, le Client dispose d'un délai de 14 jours francs pour exercer son droit de rétractation à compter de la signature du contrat.",
    "art4P2": "Toutefois, si le Client exige que l'exécution de la prestation commence avant la fin du délai de rétractation, il accepte expressément de renoncer à son droit de rétractation pour les prestations déjà exécutées.",
    "art5Title": "Article 5 - Obligations des Parties",
    "art5_1Title": "5.1. Engagements du Prestataire",
    "art5_1P1": "Le Prestataire s'engage à fournir un personnel hautement qualifié, formé aux protocoles \"palace\", équipé de ses propres microfibres à code couleur, et tenu à un devoir de discrétion absolue.",
    "art5_2Title": "5.2. Engagements du Client",
    "art5_2P1": "Le Client s'engage à garantir un accès sécurisé au logement, à déclarer tout objet de très grande valeur ou particulièrement fragile lors de l'audit, et à avertir de toute modification de planning au minimum 48 heures à l'avance. Toute prestation annulée hors de ce délai sera facturée à hauteur de 50%.",
    "art6Title": "Article 6 - Responsabilité, Assurance et Bris d'Objet",
    "art6P1": "Le Prestataire souscrit une assurance Responsabilité Civile Professionnelle spécifique couvrant les dommages corporels, matériels et immatériels qui pourraient être causés par ses intervenants au domicile du Client.",
    "art6P2": "En cas de casse ou de détérioration d'un objet précieux, le Client dispose de 48 heures pour en informer le Prestataire par écrit, photos à l'appui. Sont exclus de toute indemnisation : l'usure normale, les objets déjà fragilisés, ou les dommages liés à des installations électriques/plomberie vétustes.",
    "art7Title": "Article 7 - Discrétion et Confidentialité",
    "art7P1": "La confidentialité est la pierre angulaire de notre service d'excellence. L'ensemble des collaborateurs du Prestataire signe un Accord de Non-Divulgation (NDA) strict. Aucune information concernant la vie privée, les biens, ou l'identité du Client ne sera divulguée. Aucune photographie du domicile ne peut être prise en dehors du rapport photographique de fin de prestation, stocké de manière chiffrée sur l'Espace VIP.",
    "art8Title": "Article 8 - Durée et Résiliation",
    "art8P1": "Les contrats d'entretien récurrents sont conclus pour une durée indéterminée, avec une période d'essai d'un mois. Passé ce délai, chaque partie peut résilier le contrat par lettre recommandée ou email avec accusé de réception, moyennant le respect d'un préavis d'un mois.",
    "art9Title": "Article 9 - Droit Applicable et Médiation",
    "art9P1": "Les présentes CGV sont soumises au droit français. Conformément au Code de la consommation, en cas de litige, le Client peut recourir gratuitement au service de médiation dont dépend le Prestataire avant toute action devant les tribunaux compétents."
  },
  "legalPage": {
    "headerTitle": "Mentions Légales",
    "headerSubtitle": "& Politique de Confidentialité",
    "lastUpdate": "Dernière mise à jour : {{date}}",
    "art1Title": "1. Éditeur du Site",
    "art1P1": "En vertu de l'article 6 de la loi n° 2004-575 du 21 juin 2004 pour la confiance dans l'économie numérique (LCEN), il est précisé aux utilisateurs du site <strong>L'Art du Ménage par Johanna</strong> l'identité des différents intervenants dans le cadre de sa réalisation et de son suivi :",
    "art1L1": "<strong>Raison sociale :</strong> L'Art du Ménage (SAS/SARL - <i>À compléter</i>)",
    "art1L2": "<strong>Capital social :</strong> <i>[Montant du capital]</i> euros",
    "art1L3": "<strong>Siège social :</strong> <i>[Adresse complète du siège, ex: 15 Avenue Montaigne, 75008 Paris]</i>",
    "art1L4": "<strong>RCS :</strong> Inscrite au Registre du Commerce et des Sociétés de <i>[Ville]</i> sous le numéro <i>[Numéro SIREN]</i>",
    "art1L5": "<strong>Numéro de TVA intracommunautaire :</strong> <i>[Numéro de TVA]</i>",
    "art1L6": "<strong>Email :</strong> contact@lartdumenage.fr",
    "art1L7": "<strong>Téléphone :</strong> <i>[Numéro de téléphone]</i>",
    "art2Title": "2. Activité Réglementée & Services à la Personne (SAP)",
    "art2P1": "La société L'Art du Ménage est un organisme déclaré de Services à la Personne (SAP).",
    "art2L1": "<strong>Numéro de Déclaration (NOVA) :</strong> SAP<i>[Numéro à compléter]</i>",
    "art2P2": "Cette déclaration permet à nos clients de bénéficier de l'avantage fiscal prévu à l'article 199 sexdecies du Code Général des Impôts, à savoir une réduction ou un crédit d'impôt égal à 50 % des dépenses engagées, dans la limite des plafonds réglementaires en vigueur. L'entreprise est habilitée par l'URSSAF à proposer le service d'<strong>Avance Immédiate de Crédit d'Impôt</strong> (AICI), sous réserve de l'éligibilité du client et de son inscription au service géré par l'Agence Centrale des Organismes de Sécurité Sociale (ACOSS).",
    "art3Title": "3. Direction de la Publication & Hébergement",
    "art3P1": "<strong>Directeur de la publication :</strong> Madame Johanna <i>[Nom de famille]</i>, en qualité de Présidente/Gérante.<br/>Le responsable publication est une personne physique ou une personne morale.",
    "art3P2": "<strong>Hébergeur du site :</strong><br/>Le site est hébergé par Vercel Inc.<br/>Siège social : 340 S Lemon Ave #4133 Walnut, CA 91789, États-Unis.<br/>Serveurs situés dans l'Union Européenne (Région Paris/Francfort).",
    "art4Title": "4. Propriété Intellectuelle et Contrefaçons",
    "art4P1": "La société L'Art du Ménage est propriétaire exclusif des droits de propriété intellectuelle ou détient les droits d'usage sur tous les éléments accessibles sur le site, notamment les textes, images, graphismes, logos, icônes, sons, logiciels et la méthode d'intervention décrite.",
    "art4P2": "Toute reproduction, représentation, modification, publication, adaptation de tout ou partie des éléments du site, quel que soit le moyen ou le procédé utilisé, est strictement interdite, sauf autorisation écrite préalable de la direction de L'Art du Ménage.",
    "art4P3": "Toute exploitation non autorisée du site ou de l'un quelconque des éléments qu'il contient sera considérée comme constitutive d'une contrefaçon et poursuivie conformément aux dispositions des articles L.335-2 et suivants du Code de Propriété Intellectuelle, engageant la responsabilité civile et pénale du contrefacteur.",
    "art5Title": "5. Traitement des Données Personnelles (RGPD)",
    "art5P1": "Conformément à la loi n° 78-17 du 6 janvier 1978 modifiée, relative à l'informatique, aux fichiers et aux libertés, et au Règlement (UE) 2016/679 du Parlement européen et du Conseil du 27 avril 2016 (RGPD), L'Art du Ménage s'engage à garantir la confidentialité et la sécurité des données à caractère personnel de ses clients et prospects.",
    "art5_1Title": "5.1. Nature des données collectées",
    "art5_1P1": "Les informations recueillies via nos formulaires (demande d'audit, prise de contact, inscription URSSAF) incluent : nom, prénom, adresse postale, adresse e-mail, numéro de téléphone, superficie du logement, besoins spécifiques en matière d'entretien, et données bancaires (exclusivement gérées de manière sécurisée pour le mandat de prélèvement URSSAF).",
    "art5_2Title": "5.2. Finalité du traitement",
    "art5_2P1": "Ces données sont strictement nécessaires à l'exécution du contrat de prestation de services, à la gestion de la relation client (CRM), à l'établissement des devis et factures, ainsi qu'à la télé-déclaration auprès de l'URSSAF pour l'Avance Immédiate.",
    "art5_3Title": "5.3. Droits des utilisateurs",
    "art5_3P1": "Tout utilisateur dispose d'un droit d'accès, de rectification, d'effacement (droit à l'oubli), de limitation, d'opposition et de portabilité de ses données personnelles. Pour exercer ces droits, l'utilisateur peut adresser une demande écrite par email à l'adresse du Délégué à la Protection des Données (DPO) : <strong>dpo@lartdumenage.fr</strong>, accompagnée d'une copie d'un titre d'identité valide.",
    "art6Title": "6. Médiation de la Consommation",
    "art6P1": "Conformément aux dispositions des articles L. 611-1 et suivants du Code de la consommation, tout consommateur a le droit de recourir gratuitement à un médiateur de la consommation en vue de la résolution amiable du litige qui l'oppose à un professionnel.",
    "art6P2": "En cas de litige non résolu par notre service client, vous pouvez saisir le médiateur compétent : <i>[Nom de l'entité de médiation, ex: La Médiation de l'Assurance ou CM2C]</i>, dont les coordonnées sont : <i>[Adresse et site web du médiateur]</i>.",
    "art7Title": "7. Limitation de Responsabilité",
    "art7P1": "L'Art du Ménage s'efforce de fournir sur le site des informations aussi précises que possible. Toutefois, l'entreprise ne pourra être tenue responsable des omissions, des inexactitudes et des carences dans la mise à jour, qu'elles soient de son fait ou du fait des tiers partenaires qui lui fournissent ces informations.",
    "art7P2": "Le site utilise la technologie JavaScript. L'entreprise ne pourra être tenue responsable de dommages matériels liés à l'utilisation du site. De plus, l'utilisateur du site s'engage à y accéder en utilisant un matériel récent, ne contenant pas de virus et avec un navigateur de dernière génération mis-à-jour.",
    "art8Title": "8. Droit Applicable et Attribution de Juridiction",
    "art8P1": "Tout litige en relation avec l'utilisation du site est soumis au droit français. En dehors des cas où la loi ne le permet pas, il est fait attribution exclusive de juridiction aux tribunaux compétents du ressort du siège social de L'Art du Ménage."
  },
  "blog": {
    "headerTitle": "Nos Réalisations",
    "headerSubtitle": "Nos Conseils & Méthodes",
    "sectionTitle": "L'Art de l'Excellence",
    "sectionDesc": "Découvrez les secrets de nos gouvernantes, nos méthodes exclusives d'entretien des matériaux nobles, et nos conseils pour cultiver l'harmonie de votre intérieur.",
    "readArticle": "Lire l'article",
    "backToBlog": "Retour aux réalisations",
    "articles": [
      {
        "id": "secret-des-palaces-aeration",
        "title": "Le secret des palaces : L'art de la purification de l'air",
        "excerpt": "Avant même de toucher une surface, l'excellence commence par l'invisible. Découvrez pourquoi le protocole d'aération est la pierre angulaire de notre méthode.",
        "category": "Méthodologie",
        "date": "12 Juin 2026",
        "image": "/assets/rules/rule4.webp",
        "content": "Dans l'hôtellerie de luxe, le premier sens sollicité par un client lorsqu'il pénètre dans sa suite n'est pas la vue, mais l'odorat. Une pièce confinée, même visuellement immaculée, perd immédiatement son aura de prestige.\n\nChez L'Art du Ménage, notre protocole exige une aération systématique de 15 minutes minimum avant de commencer toute prestation. Cela permet non seulement d'évacuer les composés organiques volatils (COV), mais aussi d'assainir l'environnement de travail.\n\nNous associons cette aération à l'utilisation d'huiles essentielles purifiantes, vaporisées avec parcimonie sur les textiles (si compatibles). L'objectif n'est pas de masquer les odeurs par des parfums de synthèse lourds, mais de créer une signature olfactive neutre, fraîche et apaisante."
      },
      {
        "id": "entretenir-le-marbre",
        "title": "Comment entretenir le marbre sans l'altérer ?",
        "excerpt": "Matériau noble par excellence, le marbre est aussi l'un des plus fragiles. Nos conseils pour le nettoyer tout en préservant son éclat naturel.",
        "category": "Soin des matériaux",
        "date": "05 Juin 2026",
        "image": "/assets/rules/rule5.webp",
        "content": "Le marbre est une pierre calcaire poreuse. C'est cette composition qui lui donne ses veines uniques, mais c'est aussi ce qui le rend vulnérable aux attaques acides.\n\nLa règle absolue de nos gouvernantes : bannir le vinaigre blanc, le citron, ou tout produit anticalcaire classique sur du marbre. Une seule goutte suffit pour attaquer la couche polie et laisser une tache mate indélébile.\n\nNotre méthode repose sur l'utilisation exclusive de savons au pH neutre (comme le savon noir véritable, très dilué) et de microfibres extrêmement douces. Pour lui redonner de la brillance, un lustrage à sec avec une peau de chamois ou une microfibre spécifique suffit. En cas de tache de gras, la terre de Sommières reste votre meilleure alliée : appliquez, laissez absorber 24h, et brossez délicatement."
      },
      {
        "id": "code-couleur-microfibres",
        "title": "Le code couleur des microfibres : stopper la contamination",
        "excerpt": "Pourquoi utiliser le même chiffon pour la salle de bain et la cuisine est une aberration sanitaire. Explication de notre protocole strict.",
        "category": "Hygiène",
        "date": "28 Mai 2026",
        "image": "/assets/rules/rule2.webp",
        "content": "C'est une règle d'hygiène fondamentale souvent ignorée dans l'entretien ménager traditionnel : la gestion de la contamination croisée.\n\nNotre personnel est équipé d'un jeu de microfibres codé par couleur. Rouge pour les sanitaires, Jaune pour la salle de bain, Vert pour la cuisine, et Bleu pour les poussières et les surfaces générales. Ce système garantit qu'une bactérie présente sur les toilettes ne finira jamais sur le plan de travail de votre cuisine.\n\nDe plus, nos microfibres sont lavées à 60°C minimum avec un désinfectant textile, sans adoucissant (qui détruit leur pouvoir électrostatique et absorbant). Ce souci du détail est ce qui sépare un nettoyage amateur d'une prestation d'excellence."
      },
      {
        "id": "dresser-un-lit-au-cordeau",
        "title": "Dresser un lit au cordeau : les astuces des gouvernantes",
        "excerpt": "Découvrez la technique du 'coin au carré' pour un lit digne des plus grands palaces parisiens.",
        "category": "Chambre & Linge",
        "date": "15 Mai 2026",
        "image": "/assets/luxury_interior.webp",
        "content": "Un lit parfaitement dressé est une invitation au sommeil réparateur. La technique du 'coin au carré' (ou Hospital Corner) est exigée de toutes nos gouvernantes.\n\n1. Rentrez le drap plat sous le matelas au pied du lit.\n2. Saisissez le drap qui pend sur le côté, à environ 30 cm du pied, et soulevez-le pour former un angle à 45 degrés sur le dessus du matelas.\n3. Rentrez la partie triangulaire qui pend encore en bas, puis rabattez la partie que vous teniez par-dessus et glissez-la fermement sous le matelas.\n\nCe pliage assure une tension parfaite du drap. Nous terminons toujours par un alignement millimétré des oreillers et un lissage de la couette pour chasser toute imperfection visuelle."
      },
      {
        "id": "ecologie-sans-compromis",
        "title": "Cires naturelles vs Chimie : l'exigence écologique",
        "excerpt": "Il est possible d'allier un résultat de nettoyage parfait avec le respect total de votre santé et de la planète.",
        "category": "Écologie",
        "date": "02 Mai 2026",
        "image": "/assets/luxury_gloves.webp",
        "content": "L'idée qu'un produit doit sentir fort et contenir des produits chimiques agressifs pour être efficace est un mythe que nous déconstruisons chaque jour.\n\nLes produits industriels laissent souvent un film toxique sur vos surfaces (tables, plans de travail, sols où jouent vos enfants). Chez L'Art du Ménage, nous privilégions la chimie douce : des tensioactifs d'origine végétale, des nettoyants probiotiques, et des cires naturelles d'abeille ou de carnauba pour nourrir le bois.\n\nCette approche protège non seulement vos poumons et votre peau, mais elle prolonge également la durée de vie de vos matériaux nobles qui sont souvent 'brûlés' à petit feu par l'agressivité de la javel ou de l'ammoniaque."
      },
      {
        "id": "soin-du-cuir",
        "title": "Le soin du cuir : hydratation et protection",
        "excerpt": "Un canapé en cuir ne se nettoie pas, il se nourrit. Nos secrets pour éviter les craquelures et préserver la patine.",
        "category": "Soin des matériaux",
        "date": "18 Avril 2026",
        "image": "/assets/luxury_interior.webp",
        "content": "Le cuir est une matière vivante. Comme la peau humaine, s'il n'est pas nettoyé et hydraté, il s'assèche, se ternit et finit par craqueler.\n\nPour l'entretien courant, nos gouvernantes utilisent simplement un chiffon doux à peine humide pour dépoussiérer, car la poussière agit comme un abrasif microscopique dans les plis du cuir.\n\nDeux à trois fois par an, nous appliquons un protocole de soin profond : nettoyage au savon pour cuir (pour ouvrir les pores), suivi d'un massage avec une crème nourrissante spécifique (à base de lanoline ou de cire d'abeille). Le résultat ? Un cuir souple, qui retrouve sa couleur profonde et résiste mieux aux taches quotidiennes."
      },
      {
        "id": "importance-inspection-finale",
        "title": "L'inspection finale : la règle des 15 minutes",
        "excerpt": "L'erreur est humaine. C'est pourquoi la dernière étape de notre protocole est exclusivement dédiée au contrôle.",
        "category": "Méthodologie",
        "date": "04 Avril 2026",
        "image": "/assets/rules/rule7.webp",
        "content": "L'une des plus grandes différences entre notre service et une prestation standard réside dans la gestion de la fin de l'intervention.\n\nNos équipes ont l'ordre strict d'arrêter toute activité de nettoyage 15 minutes avant la fin de leur vacation. Ce quart d'heure est dédié au 'recul'. La gouvernante parcourt chaque pièce, non pas avec un chiffon, mais avec ses yeux.\n\nElle vérifie les reflets sur les vitres et miroirs, s'assure que les robinetteries brillent sous la lumière, replace parfaitement les chaises, aligne les coussins et vérifie que toutes les lumières sont éteintes et les portes verrouillées. C'est cette prise de recul qui garantit notre résultat 'zéro défaut'."
      },
      {
        "id": "argenterie-et-cuivres",
        "title": "Argenterie et cuivres : les raviver sans les rayer",
        "excerpt": "Comment redonner de l'éclat à vos pièces précieuses sans utiliser de pâtes abrasives destructrices.",
        "category": "Orfèvrerie",
        "date": "20 Mars 2026",
        "image": "/assets/luxury_interior.webp",
        "content": "L'oxydation est l'ennemi de l'argenterie et des cuivres, mais les produits du commerce sont souvent trop abrasifs et rayent le métal à long terme, retirant peu à peu la couche d'argent massif.\n\nNous privilégions des méthodes douces. Pour l'argenterie, une pâte faite de blanc de Meudon et d'un peu d'eau, appliquée avec une chamoisine, fait des miracles sans micro-rayures. Le rinçage doit être immédiat et le séchage minutieux.\n\nPour prévenir l'oxydation de vos pièces d'apparat exposées, le secret réside dans un dépoussiérage très régulier, car l'accumulation de poussière accélère la réaction chimique d'oxydation de l'argent."
      },
      {
        "id": "symetrie-et-rangement",
        "title": "La symétrie dans le rangement : l'esprit apaisé",
        "excerpt": "L'ordre visuel a un impact direct sur votre charge mentale. La règle du parallélisme expliquée.",
        "category": "Art de vivre",
        "date": "05 Mars 2026",
        "image": "/assets/rules/rule6.webp",
        "content": "Un espace peut être d'une propreté clinique, s'il est désordonné, l'impression de chaos persiste. La psychologie de l'espace nous apprend que notre cerveau cherche constamment des motifs et de l'ordre géométrique.\n\nNos gouvernantes sont formées à la 'mise au carré'. Les magazines sur la table basse sont alignés parallèlement aux bords de la table. Les coussins du canapé sont symétriques. Les chaises sont replacées à équidistance.\n\nCette rigueur géométrique transforme instantanément l'atmosphère d'une pièce. Lorsque vous rentrez chez vous, cet ordre absolu indique immédiatement à votre cerveau qu'il peut se détendre. C'est la véritable définition d'un service de luxe : anticiper votre bien-être psychologique."
      },
      {
        "id": "salles-de-bain-robinetterie",
        "title": "Salles de bain : le secret d'une robinetterie étincelante",
        "excerpt": "Comment éliminer le calcaire sans détruire le chrome ou les finitions dorées de votre salle de bain.",
        "category": "Soin des matériaux",
        "date": "18 Février 2026",
        "image": "/assets/rules/rule1.webp",
        "content": "Le tartre et le calcaire ternissent très vite les salles de bain, mais les anticalcaires puissants finissent par piquer le chrome, noircir le laiton ou oxyder l'or des robinetteries haut de gamme.\n\nLe protocole de L'Art du Ménage repose sur la prévention et la douceur. Nous utilisons des solutions à base d'acide citrique très dilué (moins agressif que l'acide chlorhydrique des produits industriels) que nous ne laissons jamais poser plus de quelques minutes.\n\nL'étape cruciale n'est d'ailleurs pas le produit, mais le séchage. Une robinetterie ne brillera jamais vraiment si elle n'est pas essuyée méticuleusement à sec avec une microfibre de finition après rinçage. C'est ce polissage final qui fait toute la différence."
      }
    ]
  },
  "landing": {
    "title": "L'exigence d'un service hôtelier 5 étoiles, directement chez vous",
    "subtitle": "Vous payez pour être tranquille, pas pour manager votre personnel de maison.",
    "methods": [
      {
        "title": "Évaluation sur-mesure",
        "desc": "Un audit complet de vos besoins et de vos matériaux précieux."
      },
      {
        "title": "Autonomie & Discrétion",
        "desc": "Notre personnel gère tout de A à Z. Zéro charge mentale."
      },
      {
        "title": "Standards hôteliers",
        "desc": "Un niveau d'exigence et de finition digne des plus grands palaces."
      }
    ],
    "footer": {
      "copyright": "© {{year}} L'art du Ménage. Tous droits réservés."
    },
    "floatingCta": "Réserver mon audit gratuit"
  }
}